<svg
    class="gable"
    viewBox="0 0 48 48"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true">
    <defs>
        <linearGradient [attr.id]="gradientId" x1="0" y1="0" x2="1" y2="1">
            <stop offset="0%" stop-color="#4089F1"/>
            <stop offset="100%" stop-color="#6465DA"/>
        </linearGradient>
    </defs>

    <circle class="disc" cx="24" cy="24" r="24" [attr.fill]="'url(#' + gradientId + ')'"/>

    <g class="glyph" transform="translate(11 11) scale(0.1016)">
        <path
            fill="#FFFFFF"
            d="M200,48H136V16a8,8,0,0,0-16,0V48H56A32,32,0,0,0,24,80V192a32,32,0,0,0,32,32H200a32,32,0,0,0,32-32V80A32,32,0,0,0,200,48ZM104,140a12,12,0,1,1-12-12A12,12,0,0,1,104,140Zm60,0a12,12,0,1,1-12-12A12,12,0,0,1,164,140Z"/>
    </g>

    <g class="thought-bubble" aria-hidden="true">
        <circle class="bubble bubble-1" cx="42" cy="8" r="2" fill="#C1DDFC" stroke="#1B1E23" stroke-width="0.5"/>
        <circle class="bubble bubble-2" cx="49" cy="2" r="3.5" fill="#C1DDFC" stroke="#1B1E23" stroke-width="0.6"/>
        <circle class="bubble bubble-3" cx="62" cy="-10" r="10" fill="#C1DDFC" stroke="#1B1E23" stroke-width="0.7"/>
    </g>
</svg>
